// Remote Access page — pure helpers (epic NEXUS-535). Kept DOM-free so they are unit-testable.
export const TERMINAL_PATH = '/v1/admin/remote-access/terminal';
/** ws(s):// URL for the terminal, from the provider's apiBase ('/api' or 'https://gateway…'). */
export function terminalUrl(apiBase, loc) {
    const base = apiBase.replace(/\/+$/, '');
    if (/^https?:\/\//i.test(base))
        return base.replace(/^http/i, 'ws') + TERMINAL_PATH;
    const proto = loc.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${proto}//${loc.host}${base}${TERMINAL_PATH}`;
}
/** Best keychain item for a password prompt: same account first, then sudo-purpose, then any. */
export function pickCredentialForPrompt(items, prompt, sessionAccount) {
    if (!prompt.kind || items.length === 0)
        return null;
    const want = prompt.account ?? sessionAccount;
    const byAccount = items.filter((i) => i.account === want);
    const pool = byAccount.length ? byAccount : items;
    return pool.find((i) => i.purpose === (prompt.kind === 'sudo' ? 'sudo' : 'login')) ?? pool.find((i) => i.purpose === 'sudo') ?? pool[0] ?? null;
}
export const OS_GROUPS = [
    { os: 'linux', label: 'Linux' },
    { os: 'windows', label: 'Windows' },
    { os: 'macos', label: 'macOS' },
];
export function shellLabel(t) {
    if (t.shell)
        return t.shell === 'pwsh' || t.shell === 'powershell' ? 'PowerShell' : t.shell;
    return t.os === 'windows' ? 'PowerShell' : t.os === 'macos' ? 'zsh' : 'bash';
}
/** "1h 02m" style duration for the sessions table. */
export function formatDuration(startIso, endIso, now = Date.now()) {
    const ms = Math.max(0, (endIso ? Date.parse(endIso) : now) - Date.parse(startIso));
    const m = Math.floor(ms / 60_000);
    return m >= 60 ? `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, '0')}m` : `${m}m`;
}
//# sourceMappingURL=helpers.js.map